import type { IconName } from "../../../components/Icon/Icon.tsx";
import {
  BRAND_ASSETS_CATEGORY,
  MOODBOARDS_CATEGORY,
  OUTDOOR_PHOTO_SHOOT_CATEGORY,
  PORTRAITS_CATEGORY,
  PRODUCT_PACK_SHOTS_CATEGORY,
  SOCIAL_AND_ADS_VISUALS_CATEGORY,
  STOCK_IMAGES_CATEGORY,
  STUDIO_PHOTO_SHOOT_CATEGORY,
} from "./constants.ts";
import type { QuickActionCategory } from "./types.ts";

export const CATEGORY_ICONS: Record<QuickActionCategory, IconName> = {
  [SOCIAL_AND_ADS_VISUALS_CATEGORY]: "MessageCircleHeart",
  [PRODUCT_PACK_SHOTS_CATEGORY]: "Shirt",
  [OUTDOOR_PHOTO_SHOOT_CATEGORY]: "Trees",
  [STUDIO_PHOTO_SHOOT_CATEGORY]: "LampDesk",
  [MOODBOARDS_CATEGORY]: "LayoutDashboard",
  [BRAND_ASSETS_CATEGORY]: "Tag",
  [PORTRAITS_CATEGORY]: "SquareUser",
  [STOCK_IMAGES_CATEGORY]: "Images",
};
